const DashboardModule = () =>
  import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/DashboardModule.vue");
const Dashboard = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Dashboard.vue");
// const Import = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Import.vue");
const Clients = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Clients.vue");
const Users = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Users.vue");
// const Reports = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Reports.vue");
const Settings = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Settings.vue");
// const Subscription = () =>
//   import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/Subscription.vue");
const ESanchit = () => import(/* webpackChunkName: 'dashboard' */ "@/modules/DashboardModule/pages/ESanchit.vue");
const Export = () => import(/* webpackChunkName: 'export' */ "@/modules/DashboardModule/pages/Export.vue");
import { ImportExportModuleRoutes } from "./modules/ImportExportModule/routes";

export const DashboardRoutes = [
  {
    path: "/dashboard",
    component: DashboardModule,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/",
        name: "dashboard.home",
        component: Dashboard
      },
      {
        path: "clients",
        name: "dashboard.clients",
        component: Clients
      },
      {
        path: "users",
        name: "dashboard.users",
        component: Users
      },
      //   {
      //     path: "reports",
      //     name: "dashboard.reports",
      //     component: Reports
      //   },
      {
        path: "settings",
        name: "dashboard.settings",
        component: Settings
      },
      //   {
      //     path: "subscription",
      //     name: "dashboard.subscription",
      //     component: Subscription
      //   },
      {
        path: "e-sanchit",
        name: "dashboard.eSanchit",
        component: ESanchit
      },
      {
        path: "export",
        name: "dashboard.export",
        component: Export
      },
      ...ImportExportModuleRoutes
    ]
  }
];
